import { render, staticRenderFns } from "./VehiclesCsvImportModal.vue?vue&type=template&id=5028a54d&scoped=true&"
import script from "./VehiclesCsvImportModal.vue?vue&type=script&lang=js&"
export * from "./VehiclesCsvImportModal.vue?vue&type=script&lang=js&"
import style0 from "./VehiclesCsvImportModal.vue?vue&type=style&index=0&id=5028a54d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5028a54d",
  null
  
)

export default component.exports